import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    component: () => import('@/views/UserLayout.vue'),
    children: [
      {
        path: '',
        redirect: '/home'
      },
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: { title: '首页' }
      },
      {
        path: 'menu',
        name: 'Menu',
        component: () => import('@/views/Menu.vue'),
        meta: { title: '点餐' }
      },
      {
        path: 'cart',
        name: 'Cart',
        component: () => import('@/views/Cart.vue'),
        meta: { title: '购物车' }
      },
      {
        path: 'orders',
        name: 'Orders',
        component: () => import('@/views/Orders.vue'),
        meta: { title: '订单' }
      },
      {
        path: 'orders/:id',
        name: 'OrderDetail',
        component: () => import('@/views/OrderDetail.vue'),
        meta: { title: '订单详情' }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/Profile.vue'),
        meta: { title: '我的' }
      },
      {
        path: 'profile/info',
        name: 'ProfileInfo',
        component: () => import('@/views/ProfileInfo.vue'),
        meta: { title: '个人信息' }
      },
      {
        path: 'profile/address',
        name: 'AddressList',
        component: () => import('@/views/AddressList.vue'),
        meta: { title: '收货地址' }
      },
      {
        path: 'profile/address/add',
        name: 'AddressAdd',
        component: () => import('@/views/AddressEdit.vue'),
        meta: { title: '添加地址' }
      },
      {
        path: 'profile/address/edit/:id',
        name: 'AddressEdit',
        component: () => import('@/views/AddressEdit.vue'),
        meta: { title: '编辑地址' }
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title + ' - 扫码点餐';
  }
  next();
});

export default router;


